import {
  Typography,
  Card,
  Box,
  Divider,
  useMediaQuery,
  Theme,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { useRecordContext } from "react-admin";
import { StatementStatusLabel } from "./StatementStatusLabel";
import AnimatedBlock from "../../../components/Common/AnimatedBlock";
import InfoRow from "../../../components/Common/InfoRow";
import ValidateAction from "./ValidateAction";
import DownloadPdfAction from "./DownloadPdfAction";
import { ProjectField } from "../ProjectField";
import { formatDateTime, formatEuro } from "../../../utils/paymentFormat";

// A billing month as read (2026-06 → June 2026).
export const monthLabel = (month?: string) => {
  const date = new Date(`${month}-01T00:00:00`);
  return !month || Number.isNaN(date.getTime()) ? month || "" : date.toLocaleDateString("en-GB", { month: "long", year: "numeric" });
};

function InfoStatementTab() {
  const { t }: { t: any } = useTranslation();
  const isMobile = useMediaQuery<Theme>((theme) => theme.breakpoints.down("sm"));
  const record = useRecordContext();

  if (!record) return null;

  return (
    <Box>
      {!isMobile && (
        <Box pb={2}>
          <Typography variant="h6">
            {t("Summary")}
          </Typography>
          <Typography variant="body2" color="text.secondary">
            {t("The gas station fees billed to the entity for this month.")}
          </Typography>
        </Box>
      )}

      <AnimatedBlock>
        <Card>
          <Box px={2} pt={2.5} pb={1.5} display="flex" alignItems="center" justifyContent="space-between" gap={2} flexWrap="wrap">
            <Typography variant="h5" fontWeight="bold">
              {t("Statement")}
            </Typography>
            <Box display="flex" gap={2}>
              <DownloadPdfAction />
              <ValidateAction />
            </Box>
          </Box>
          <Divider />
          <Box px={2} py={1}>
            <InfoRow label={t("Month")}>{monthLabel(record.month)}</InfoRow>
            <InfoRow label={t("Status")}>
              <StatementStatusLabel />
            </InfoRow>
            <InfoRow label={t("Entity")}>
              <Box component="span" sx={{ "& .MuiTypography-root": { fontWeight: 700 } }}>
                <ProjectField />
              </Box>
            </InfoRow>
            <InfoRow label={t("Total fee")}>{formatEuro(record.totalFeeEur) || "—"}</InfoRow>
            <InfoRow label={t("Validated by")}>
              {record.validatedBy ? (
                <Typography component="span" sx={{ fontFamily: "monospace", fontSize: 13, fontWeight: 400 }}>
                  {record.validatedBy}
                </Typography>
              ) : (
                "—"
              )}
            </InfoRow>
            <InfoRow label={t("Validated at")}>{formatDateTime(record.validatedAt) || "—"}</InfoRow>
            <InfoRow label={t("ID")}>
              <Typography component="span" sx={{ fontFamily: "monospace", fontSize: 13, fontWeight: 400 }}>
                {record.id}
              </Typography>
            </InfoRow>
          </Box>
        </Card>
      </AnimatedBlock>
    </Box>
  );
}

export default InfoStatementTab;
